module.exports = __webpack_public_path__ + "static/media/sales.fd9afe33.png";